import { PageLayout } from '@/ui/layouts/PageLayout'
import { BridgePanel } from '@/features/bridge/components/BridgePanel'
import { BridgeViewProps } from '../logic/types'
import { cn } from '@/ui/utils/style'

export function BridgeView(props: BridgeViewProps) {
  const { bridge, withHeading } = props

  return (
    <PageLayout className={cn(withHeading ? 'mt-8' : 'p-0')}>
      <div className="flex justify-center">
        <BridgePanel bridge={bridge} withHeading={withHeading} />
      </div>
    </PageLayout>
  )
}
